/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 16/01/2014
 * Time: 16:05
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('AvailableDayPrView',["$log","DayPrData","Period",
        function ($log,DayPrData,Period){
        //special object contains available period for a day and an pr
        var  AvailableDayPrView = function(dayPr,prView,prUnitId,aDayView)
        {
            this.prView = prView;
            this.prUnitId = prUnitId;
            this.dayPrIndex = -1;      // index inside DayPrData
            this.aDayView = aDayView;
            this.availablePeriods = []; // periods availables


            //Load activities of daypr
            if (dayPr !== undefined && dayPr)
            {
                this.dayPrIndex = DayPrData.getIndexOf(dayPr);
                for (let i = 0; i < dayPr.availablePeriods.length; i++) {
                    this.availablePeriods.push(new Period(dayPr.availablePeriods[i]))
                }
                if (this.availablePeriods.length > 0) {
                    this.availablePeriods.sort(Period.prototype.compare);
                }
            }
        };

        AvailableDayPrView.prototype.getModel= function()
        {

            if (this.dayPrIndex!=-1)
            {
                return DayPrData.getByIndex(this.dayPrIndex);
            }
            return null;
        };

        AvailableDayPrView.prototype.isAvailableForBookingView = function(bookingView,cPeriod)
        {
            var isAvailable = false;
            isAvailable = this.isAvailableForPeriod(bookingView.period,cPeriod);
/*
            for (var i= 0; i<bookingView.bookingServicesView.length;i++)
            {
                isAvailable = this.isAvailableForPeriod(bookingView.bookingServicesView[i].period);
            }
*/
            return isAvailable;
        };

        AvailableDayPrView.prototype.isAvailableForBookingServiceView  = function(bsView)
        {
            if (!bsView || !bsView.period)
                return false;
            if (!this.prView.knowsServiceView(bsView.serviceView))
                return false;
            return this.isAvailableForPeriod(bsView.period);
        };

        AvailableDayPrView.prototype.isAvailableForPeriod= function(period,cPeriod)
        {
            var isAvailable = false;
            var i= 0;
            if (period)
                for (i= 0; i<this.availablePeriods.length && !isAvailable && this.availablePeriods[i].start.getTime()<=period.start.getTime();i++)
                    isAvailable = this.availablePeriods[i].contains(period);

            return isAvailable;
        };

        AvailableDayPrView.prototype.getAvailablePeriodByStart= function(start)
        {
            for (var i= 0; i<this.availablePeriods.length && this.availablePeriods[i].start.getTime()<=start.getTime();i++) //ordered then test if out of period
                if (this.availablePeriods[i].start.getTime()<=start.getTime() && this.availablePeriods[i].end.getTime()>=start.getTime())
                    return this.availablePeriods[i];

            return null;
        };

        AvailableDayPrView.prototype.getNextAvailablePeriodByStart= function(start)
        {
            for (var i= 0; i<this.availablePeriods.length;i++)
                if (this.availablePeriods[i].start.getTime()>=start.getTime())//return first next
                    return this.availablePeriods[i];

            return null;
        };

        return  AvailableDayPrView;
    }]);


// WEBPACK FOOTER //
// ./js/services/customerSite/views/AvailableDayPrView.js